import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { company } from '~/company/Company';
import { orderStore, userStore } from '~/stores';
import {
  RecommendationConfig,
  RecommendationStore,
} from '~/stores/RecommendationsStore';

import styles from './RecommendationSection.module.scss';
import RecommendationSlider from './RecommendationSlider';

interface RecommendationSectionProps {
  store: RecommendationStore;
  config: RecommendationConfig;
  className?: string;
}

const RecommendationSection = ({
  store,
  config,
  className,
}: RecommendationSectionProps) => {
  const isEnabled = company[config.companyFlag];

  useEffect(() => {
    const shouldLoad =
      isEnabled &&
      userStore.isAuthorized &&
      orderStore.etaWarehouseCode &&
      !store.productsRequest.isLoading;

    if (shouldLoad) {
      store.productsRequest.run();
    }
  }, []);

  if (!isEnabled || !userStore.isAuthorized || !store.collection) {
    return null;
  }

  return (
    <div className={className || styles.root}>
      <RecommendationSlider
        collection={store.collection}
        hideBadges={config.hideBadges}
        size={config.size}
      />
    </div>
  );
};

export default observer(RecommendationSection);
